import _ from 'lodash';
import { getBase } from '../common/uri';

export const getDeepUrl = (config, params, document) => {
  var url = getBase(document);
  var rpos = config.selections.rpos;
  var accessories = config.selections.accessories;

  var query = {
    styleId: config.styleId,
    rpo: rpos
      .slice()
      .concat(accessories)
      .join(','),
    ss: config.ss,
    postalCode: _.get(params, 'postalCode')
  };
  var queryString = _.keys(query)
    .filter(function(key) {
      return query[key];
    })
    .map(function(key) {
      return key + '=' + query[key];
    })
    .join('&');

  return url + 'summary?' + queryString;
};
